/**
 * Class Name Utility
 *
 * Combines clsx and tw-merge for Tailwind class merging
 */

import { clsx, type ClassValue } from 'clsx';

/**
 * Merge class names with proper Tailwind class precedence
 *
 * @param inputs - Class names to merge
 * @returns Merged class string
 *
 * @example
 * cn('px-4 py-2', 'bg-blue-500', { 'text-white': true })
 * // => 'px-4 py-2 bg-blue-500 text-white'
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
